import {
  strategyPrivateRoutesV2,
  strategyPublicRoutesV2,
} from "../features/Strategy/routes";

import plansRoutes from "../features/Plans/routes";
import { adminRoutes } from "features/Admin/routes";
import { hostRoutes } from "features/Host/routes";
import { marketRoutesV2 } from "../features/Market/routes";
import { exploreRoutesV2 } from "../features/Explore/routes";
import { researchRoutesV2 } from "../features/Research/routes";
import { accountRoutesV2 } from "../features/Account/routes";
import { dashboardRoutesV2 } from "../features/Dashboard/routes";
import { helpcenterRoutesV2 } from "../features/HelpCenter/routes";
import { notificationRoutesV2 } from "../features/Notification/routes";
// import { surmountAccountRoutes } from "features/SurmountAccount/routes";
import {
  authRoutes,
  welcomePrivateRoutes,
  signupPrivateRoutes,
} from "../features/Auth/routes";

// public routes

export const publicV2Routes = [
  ...authRoutes,
  ...strategyPublicRoutesV2,
  ...marketRoutesV2,
];

// private routes
export const privateRoutes = [
  ...signupPrivateRoutes,
  ...accountRoutesV2,
  ...dashboardRoutesV2,
  ...exploreRoutesV2,
  ...researchRoutesV2,
  ...helpcenterRoutesV2,
  ...notificationRoutesV2,
  ...strategyPrivateRoutesV2,
  ...hostRoutes,
  ...adminRoutes,
  // ...surmountAccountRoutes,
  ...plansRoutes,
];

// free user routes
export const nonPremiumRoutes = [...plansRoutes, ...welcomePrivateRoutes];
